// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const bindAll = (obj: Record<string, any>): unknown => {
  for (const key of Object.getOwnPropertyNames(obj.constructor.prototype)) {
    const val = obj[key];

    if (key !== "constructor" && typeof val === "function") {
      obj[key] = val.bind(obj);
    }
  }

  return obj;
};

export const clamp = (value: number, min: number, max: number): number =>
  Math.min(Math.max(value, min), max);

export function getPercentage(
  value: number,
  minValue: number,
  maxValue: number,
): number {
  if (value < minValue) return 0;

  if (value > maxValue) return 100;

  return ((value - minValue) / (maxValue - minValue)) * 100;
}

export function isNumber(value: unknown): value is number {
  return typeof value === "number";
}

export * from "./color";
export * from "./date";
export * from "./dom";
export * from "./formatters";
export * from "./helpers";
export * from "./text";
export * from "./token";
export * from "./validators";
